import { useEffect } from "react";

export const APP_TITLE = "Lusca Search";

/**
 * Sets the browser tab title to "<title> | Lusca Search" while the calling page is mounted, and
 * restores the previous title on unmount. A falsy title (e.g. still loading) leaves the bare app
 * title so tabs never show "undefined".
 */
export default function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${APP_TITLE}` : APP_TITLE;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
